<template>
  <div class="success-screen">
    <div class="success-box">
      <h2>驗證成功</h2>
      <img src="@/assets/icon_success.png" alt="Submission Success" class="success-icon" />
      <p>系統驗證成功<br>
        您可以開始使用新密碼登入會員</p>
    </div>
    <button  class="success-button" @click="goLogin">前往登入帳號</button>
  </div>
</template>

<script>
export default {
  methods: {
    goLogin() {
      this.$router.push('/login-page');
    }
  }
};
</script>

<style scoped>
@import "@/css/apply_success.css";

</style>
